module.exports = __webpack_public_path__ + "static/media/add.ff430aba.svg";